// https://vuex.vuejs.org/en/state.html

export default {
  model: {},
  b1: {},
  bank: null,
};
